<template>
  <div>
    <SideBar></SideBar>
    <Main></Main>
  </div>
</template>
<script>
import SideBar from "@/vms/pages/layout/SideBar";
import Main from "@/vms/pages/layout/Main";

export default {
  name: "Layout",
  components: { Main, SideBar }
};
</script>


// WEBPACK FOOTER //
// src/vms/pages/layout/index.vue